// src/pages/customer/customerwidgets/WishlistCard.jsx
import React from 'react';

export default function WishlistCard({ item, onRemove }) {
  const { id, name, breed, price_inr, image_url } = item;
  const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:4000';
  const imageUrl = image_url
    ? image_url.startsWith('http') ? image_url : `${BASE_URL}${image_url}`
    : null;

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-outline-variant/10
                    overflow-hidden flex flex-col">
      <div className="h-36 bg-surface-container flex items-center justify-center">
        {imageUrl
          ? <img src={imageUrl} alt={name} className="h-full w-full object-cover" />
          : <span className="material-symbols-outlined text-[48px] text-outline">pets</span>
        }
      </div>
      <div className="p-4 flex-1 flex flex-col gap-1">
        <p className="font-black text-on-surface text-sm">{name}</p>
        <p className="text-[11px] text-secondary">{breed}</p>
        <p className="text-base font-black text-primary mt-1">₹{Number(price_inr).toLocaleString('en-IN')}</p>
        <div className="flex gap-2 mt-3">
          <button className="flex-1 py-1.5 rounded-xl bg-primary text-white font-bold text-xs
                             hover:opacity-90 transition-all">
            Inquire
          </button>
          <button
            onClick={() => onRemove?.(id)}
            className="p-1.5 rounded-xl border border-outline-variant/30 text-red-500
                       hover:bg-red-50 transition-all">
            <span className="material-symbols-outlined text-[16px]">delete</span>
          </button>
        </div>
      </div>
    </div>
  );
}
